import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import ModalUI from '../../../../../shared/components/Modal';
import { withStyles } from "@material-ui/core/styles";
import Spinner from 'react-bootstrap/Spinner';
import FormAddAlergie from './FormAddAlergie';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ListAltIcon from '@material-ui/icons/ListAlt';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePrescription, faPrescriptionBottleAlt } from "@fortawesome/free-solid-svg-icons";


/* 
-----------------
Actualizar alergia

alergias/update
PUT
{
    "id_alergia": "2",
    "nombre": "Guayaba",
    "alergia_vigente": false,
    "es_removible": true,
    "es_uso": true
}

*/
const initial_alergies = [
    {
        "AllergyId": 3896,
        "Name": "fosfato de sodio (32P)",
        "AllergyCategoryId": 1,
        "IsDisabled": false,
        "IsRemovable": false,
        "IsUsed": false
    },
    {
        "AllergyId": 3897,
        "Name": "ibritumomab tiuxetán [90Y]",
        "AllergyCategoryId": 1,
        "IsDisabled": false,
        "IsRemovable": false,
        "IsUsed": false
    },
    {
        "AllergyId": 3898,
        "Name": "Dicloruro de radio (223 Ra)",
        "AllergyCategoryId": 1,
        "IsDisabled": false,
        "IsRemovable": false,
        "IsUsed": false
    },
]



const PatientAlergies = ({ id_historia }) => {
    const [alergiesList, setAlergiesList] = useState(initial_alergies);
    const [loadedListAlergies, setLoadedListAlergies] = useState(false);
    const [patientAlergies, setPatientAlergies] = useState([]);
    const [loadedPatientAlergies, setLoadedPatientAlergies] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });
    const [errors, setErrors] = useState({});
    const [nameAlergieToAddList, setNameAlergieToAddList] = useState('');
    const [openModalFormAddAlergie, setOpenModalFormAddAlergie] = useState(false);
    const [alergieToForm, setAlergieToForm] = useState(null);
    const [editAlergie, setEditAlergie] = useState(false);
    const id_profile = sessionStorage.getItem('perfil');

    useEffect(() => {
        const getListAlergies = async () => {
            setLoadedListAlergies(true);
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias-listado/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error("Error consultando el listado de alergias");
                }
            }).then((data) => {
                if (data.length > 0) {
                    console.log("Alergias", data)
                    setAlergiesList(data);
                    setLoadedListAlergies(false);
                }
                else {
                    setAlergiesList([]);
                    setLoadedListAlergies(false);
                }
            }).catch(err => {
                console.log(err);
                setLoadedListAlergies(false);
            });
        }

        getListAlergies();
    }, [])

    useEffect(() => {
        getPatientAlergies();
    }, [])

    const getPatientAlergies = async () => {
        setLoadedPatientAlergies(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/listar?id_historia=' + id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Error consultando las alergias del paciente");
            }
        }).then((data) => {
            if (data.length > 0) {
                console.log("Alergias", data)
                setPatientAlergies(data);
            }
            setLoadedPatientAlergies(false);
        }).catch(err => {
            console.log(err);
            setLoadedPatientAlergies(false);
        });
    }


    const deleteAlergie = (id_alergia) => {
        let data = {
            id_alergia: id_alergia
        }
        fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)

        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error("Error eliminando la alergia del paciente");
            }
        }).then((data) => {
            getPatientAlergies();
            dropAlergieFormTexfield(alergieToForm);
        }).catch(err => {
            console.log(err);
        });
    }

    const handlerAddAlergies = (alergie, reason, detail) => {
        setPatientAlergies(alergie);
        if (reason === 'select-option') {
            setOpenModalFormAddAlergie(true);
            setAlergieToForm(detail.option);
        }

        if (reason === 'remove-option') {
            //deleteAlergie(detail.option.id_alergia)
            setOpenAlert(true);
            setModalAlert({ message: '¿Esta seguro que desea eliminar la alergia?', color: 'warning', title: 'Eliiminar!' })
            setAlergieToForm(detail.option);
        }
    }

    const onOkModal = () => {
        switch (modalAlert.color) {
            case "sucess":
                setOpenAlert(!openAlert);
                break;
            case "warning":
                deleteAlergie(alergieToForm.id_alergia);
                setOpenAlert(!openAlert);
                break;
            default:
                break;
        }
    }

    const onCloseModal = () => {
        setOpenAlert(!openAlert);
        getPatientAlergies();
    }

    const dropAlergieFormTexfield = (alergieToForm) => {
        let alergiesSelectedTextField = patientAlergies;
        let newAlergies = alergiesSelectedTextField.filter((alergie) => alergie.nombre !== alergieToForm.nombre);
        setPatientAlergies(newAlergies);
    }

    const onToggleToEdit = (alergie) => {
        setAlergieToForm(alergie);
        setEditAlergie(true);
        setOpenModalFormAddAlergie(true);
    }

    const onToggleToDelete = (alergie) => {
        setOpenAlert(true);
        setModalAlert({ message: '¿Esta seguro que desea eliminar la alergia?', color: 'warning', title: 'Eliiminar!' })
        setAlergieToForm(alergie);
    }

    const etapaToLetters = (etapa) => {
        let etapaName = '';
        switch (etapa) {
            case 1:
                etapaName = 'Niño';
                break;
            case 2:
                etapaName = 'Adulto';
                break;
            case 3:
                etapaName = 'Desconocido';
                break;

            default:
                etapaName = '';
                break;
        }
        return etapaName
    }

    const serverityToLetters = (numSeverity) => {
        let severityName = '';
        switch (numSeverity) {
            case 1:
                severityName = 'Muy leve';
                break;
            case 2:
                severityName = 'Leve';
                break;
            case 3:
                severityName = 'Moderado';
                break;
            case 4:
                severityName = 'Severo';
                break;

            default:
                severityName = '';
                break;
        }
        return severityName
    }

    return (
        <Fragment>
            <Col md={12} lg={12} xl={12} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <Row>
                            <div className='clinic-history-info'>
                                <div>
                                    <h4><b>ALERGIAS</b></h4>
                                </div>
                                <div>
                                    <h5>Historia Clínica No. <b>{id_historia}</b></h5>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <Col md={8} xs={12}>
                                <div className='form-add-alergies'>
                                    {
                                        !loadedListAlergies ?
                                            <FormControl
                                                error={errors.hasOwnProperty("patientAlergies") ? errors.patientAlergies !== "" : false}
                                            >
                                                <Autocomplete
                                                    multiple
                                                    id="tags-standard"
                                                    options={alergiesList}
                                                    value={patientAlergies}
                                                    disabled={id_profile !== '11' ? false : true}
                                                    getOptionLabel={(option) => option.nombre}
                                                    onChange={(event, value, reason, detail) => {
                                                        console.log("evento", event, "valor", value, "reason", reason, "detail", detail);
                                                        handlerAddAlergies(value, reason, detail);
                                                    }}
                                                    renderInput={(params) => {
                                                        console.log("WhatParams", params)
                                                        return (<TextField
                                                            {...params}
                                                            variant="standard"
                                                            label=""
                                                            placeholder="Alergia"
                                                            className='text-field-autocomplete'
                                                        />)
                                                    }}
                                                />
                                                <FormHelperText>{errors.patientAlergies}</FormHelperText>
                                            </FormControl>
                                            :
                                            <div className="text-center">
                                                <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                            </div>
                                    }
                                </div>
                            </Col>

                            {/* <Col md={4} xs={12}>
                                <div className='form-plus-new-alergie'>
                                    <div className='title'>
                                        <h4><b>Agregar Nueva Alergia</b></h4>
                                    </div>
                                    <div>
                                        <TextField
                                            label="Nombre de la Alergia"
                                            value={nameAlergieToAddList}
                                            onChange={(event) => {
                                                setNameAlergieToAddList(event.target.value)
                                            }}
                                            type="text"
                                            className="medical-material-form__field"
                                            error={errors.hasOwnProperty("nombre") ? errors.nombre !== "" : false}
                                            helperText={errors.nombre}
                                        />
                                    </div>
                                    <div>
                                        <Button
                                            size="sm"
                                            color="primary"
                                            onClick={() => {

                                            }}
                                        >
                                            Guardar
                                        </Button>
                                    </div>
                                </div>
                            </Col> */}
                        </Row>
                        <Row>
                            <Col md={8} xs={12}>
                                {loadedPatientAlergies ?
                                    <div className="text-center">
                                        <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                    </div>
                                    : patientAlergies.length > 0 ?
                                        <div className='group-cards-alergie'>
                                            {patientAlergies.map((alergie) => (
                                                <div className='card-show-alergie' key={alergie.id_alergia}>
                                                    <div className='content'>
                                                        <div><h5><b>{alergie.nombre.toUpperCase()}</b></h5></div>
                                                        <div><p><b>Severidad: </b>{serverityToLetters(alergie.severidad)}</p></div>
                                                        <div><p><b>Desde (Etapa): </b>{etapaToLetters(alergie.etapa)}</p></div>
                                                    </div>
                                                    <div className='buttons-actions'>
                                                        <div>
                                                            <Tooltip title="Editar Alergia">
                                                                <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '1em', height: '1em', marginTop: 'auto' }}
                                                                    disabled={id_profile !== '11' ? false : true}
                                                                    onClick={() => {
                                                                        onToggleToEdit(alergie);
                                                                    }}
                                                                >
                                                                    <EditOutlinedIcon style={{ color: '#153365', width: '0.8em', height: '0.8em' }} />
                                                                    {/* <FontAwesomeIcon icon={faFilePrescription} style={{ color: '#153365', width: '1em', height: '1em' }} /> */}
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                        <div>
                                                            <Tooltip title="Eliminar Alergia">
                                                                <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '1em', height: '1em', marginTop: '0.25em' }}
                                                                    disabled={id_profile !== '11' ? false : true}
                                                                    onClick={() => {
                                                                        onToggleToDelete(alergie);
                                                                    }}
                                                                >
                                                                    <DeleteForeverIcon style={{ color: '#153365', width: '0.8em', height: '0.8em' }} />
                                                                    {/* <FontAwesomeIcon icon={faFilePrescription} style={{ color: '#153365', width: '1em', height: '1em' }} /> */}
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                        : <div className="info-empty-profile">
                                            <h5>El paciente no tiene registrada ninguna alergia en el sistema</h5>
                                        </div>

                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
            {openModalFormAddAlergie == true ?
                <Fragment>
                    <Modal
                        open={openModalFormAddAlergie}
                        /* onClose={() => {
                            setOpenModalFormAddAlergie(false);
                        }} */
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ zIndex: 1000 }}
                    >
                        <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}>
                            <FormAddAlergie id_historia={id_historia} alergieToForm={alergieToForm} setOpenModalFormAddAlergie={setOpenModalFormAddAlergie} dropAlergieFormTexfield={dropAlergieFormTexfield} editAlergie={editAlergie} setEditAlergie={setEditAlergie} getPatientAlergies={getPatientAlergies} />
                        </div>
                    </Modal>
                </Fragment>
                : null
            }
            {
                openAlert ?
                    <ModalUI
                        color={modalAlert.color
                        }
                        title={modalAlert.title}
                        message={modalAlert.message}
                        modal={openAlert}
                        toggle={() => { onCloseModal() }}
                        onOk={() => onOkModal()}
                    /> : null}
        </Fragment>
    )
}

export default PatientAlergies